<!--分页查询美育浸润-->
<template>
    <div class="event-nav-content">
        <div class="event-page-container" v-show="showMode==='eventPageHome'">
            <div class="head-container">
                <div class="left-head-container">
                    <svg @click="backPage" t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#0d55a4" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                </div>
                <div class="right-head-container">{{this.itemName}}劳动实践主题活动</div>
                <div class="left-head-container">
                </div>
            </div>
            <!--列表-->
            <el-scrollbar class="museum-event-list-container">
                <div class="bre9e">
                    <el-table header-cell-class-name="bgf2"
                              show-overflow-tooltip
                              :data="dataList"
                              highlight-current-row>
                        <el-table-column type="index" align="center" label="序号" width="60" />
                        <el-table-column  label="活动名称" align="center" prop="eventTheme">
                            <template #default="scope">
                                <div :title="scope.row.practiceName" @click="queryPracticeInfo(scope.row)" style="color: #409efe;"
                                     class="text-one cursor">
                                    {{ scope.row.practiceName }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column width="140" label="年级" align="center" prop="">
                            <template #default="scope">
                                <div :title="scope.row.gradeName"
                                     class="text-one cursor">
                                    {{ scope.row.gradeName }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column width="100" label="上下册" align="center" prop="">
                            <template #default="scope">
                                <div :title="scope.row.practiceGradeName"
                                     class="text-one cursor">
                                    {{ scope.row.practiceGradeName }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column width="130" label="创建时间" align="center" prop="createTime">
                            <template #default="scope">
                                <div>{{ timestampToTime(scope.row.createTime) }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" width="100" label="操作" align="center">
                            <template #default="scope">
                                <el-button type="primary" size="small" @click="queryPracticeInfo(scope.row)">查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-scrollbar>
            <div class="page-container" v-if="dataList&&dataList.length>0">
                <pageTag :background="true"
                         :pageSizes="[10, 20, 30]"
                         v-show="total > 0"
                         :total="total"
                         v-model:page.sync="queryParams.pageNum"
                         v-model:limit.sync="queryParams.pageSize"
                         @pagination="pageList" />
            </div>
        </div>

        <!--详情-->
        <div class="event-page-container" v-show="showMode==='eventDetail'">
            <div class="head-container">
                <div class="left-head-container" @click="backHomePage">
                    <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#0d55a4" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                </div>
                <div class="right-head-container">{{practiceForm.practiceName}}</div>
                <div class="left-head-container">
                </div>
            </div>
            <el-scrollbar class="museum-event-info-container">
                <iframe :src="this.openFileUrl" frameborder="0" style="width:100%; height:calc(100vh - 150px)"></iframe>
            </el-scrollbar>
        </div>
    </div>
</template>
<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import {infoPractice, pagePractice} from "@/api/admin/practice";
import {timestampDate, timestampToTime} from "@/utils/date";
export default {
    name:'practicePageHome',
    components:{pageTag, dataEmpty},
    props:{
        itemKey:{
            type: String,
            default:null
        },
        itemName:{
            type: String,
            default:null
        },
        markInfo:{
            type: String,
            default:null
        },
    },
    watch:{
        itemKey(newValue,oldValue){
        },
        itemName(newValue,oldValue){
        },
        markInfo(newValue,oldValue){
            this.pagePracticeList();
        },

    },
    mounted() {},
    data() {
        return {
            timestampDate,
            timestampToTime,
            showMode:'eventPageHome',
            queryParams: {
                gradeKey:'',
                pageNum: 1,
                pageSize: 10,
            },
            total: 0,
            dataList: [],
            practiceId:'',
            practiceForm:{},  //数据
            openFileUrl:'',
            practiceFile:{},
        }
    },
    methods: {
        backPage(){
            this.$emit('back-practice-page', 'homePage');
        },
        backHomePage(){
            this.showMode = "eventPageHome";
        },
        pagePracticeList(){
            this.dataList = []
            this.queryParams.gradeKey = this.itemKey;
            pagePractice(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        queryPracticeInfo(event){
            infoPractice({ practiceId: event.practiceId }).then(res => {
                if (res.data.code === 1) {
                    this.practiceForm = res.data.data;
                    this.practiceFile = this.practiceForm.file;
                    this.openFileUrl = 'https://ow365.cn/?i=36735&ssl=1&furl=' +this.practiceFile.fileUrl;
                    this.showMode = "eventDetail";
                }else {
                    this.$message.error("操作失败")
                }
            });
        },
    }
}
</script>
<style>
.event-nav-content{
    width: 100%;
    height: auto;
}
.event-page-container{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.head-container{
    width: 100%;
    height: 44px;
    display: flex;
}
.left-head-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.right-head-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #0d55a4;
    line-height: 44px;
    font-weight: bold;
}
.museum-event-list-container{
    width: 100%;
    height: calc(100% - 100px)!important;
    padding: 10px;
    box-sizing: border-box;
}
.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    padding-top: 15px;
    box-sizing: border-box;
}


.museum-event-info-container{
    width: 100%;
    height: calc(100% - 30px)!important;
    padding: 0 10px 10px 10px;
    box-sizing: border-box;
}
.book-base-info-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    display: flex;
}
.event-book-container{
    width: calc(100% - 20px);
    height: 100%;
    padding-right: 20px;
    box-sizing: border-box;
}
.book-info-item-auto{
    width: 100%;
    height: auto;
    line-height: 25px;
    display: flex;
    font-size: 15px;
    margin-top: 5px;
}
.event-book-container{
    width: 85%;
    height: auto;
    display: flex;
    flex-wrap: wrap!important;
    margin-left: 30px;
    margin-top: 5px;
    margin-bottom: 10px;
}
.book-list-one{
    width: 140px;
    height: 210px;
    margin-right: 10px;
    border: 1px solid #dcdfe6;
}
.book-cover{
    width: 140px;
    height: 180px;
}
.book-t{
    color: #333333;
    font-size: 15px;
    font-family: sans-serif;
    height: 30px;
    line-height: 30px;
    white-space: nowrap; /* 防止文本换行 */
    overflow: hidden; /* 隐藏溢出的内容 */
    text-overflow: ellipsis; /* 显示省略号 */
}

.item-span{
    font-weight: bold;
    color: #0d55a4;
}

</style>